import styled from 'styled-components';
import {Badge} from './GenericBadges';
import {badgeColors} from './badgeColors';

export const SaleBadge = styled(Badge)`
  color: ${badgeColors.colors.sale};
  background-color: ${badgeColors.backgroundColors.sale};
`;
